// extracted by mini-css-extract-plugin
module.exports = {"vInk":"#131313","timer":"Timer__timer___PLhAH","minutes":"Timer__minutes___jlQRj","seconds":"Timer__seconds___bz+A4"};